import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getSeasonDivisions } from '../actions/divisionsActions';
import { getMyGames} from '../actions/gamesActions';
import { assignUmpToGame, removeUmp } from '../actions/umpireActions';
import { getSeasonUmpireData } from "./../actions/reportsActions";
import { getUmpireStats } from "./../actions/reportsActions";
import { getTeamsVolunteering } from '../actions/teamActions';
import UmpireCompletedGamesTable from '../components/UmpireCompletedGamesTableV2';

const mapDispatchToProps = dispatch => {
  return {
    getSeasonDivisions: (seasonId) => {
      dispatch(getSeasonDivisions(seasonId));
    },
    getMyGames: (season, team, umpire, startDate) => {
      dispatch(getMyGames(season, team, umpire, startDate));
    },
    getSeasonUmpireData: (seasonId) => {
      dispatch(getSeasonUmpireData(seasonId));
    },
    removeUmp: (umpireId, gameId, plate, updatedGame) => {
      dispatch(removeUmp(umpireId, gameId, plate, updatedGame));
    },
    assignUmpToGame: (umpireId, gameId, plate, updatedGame) => {
      dispatch(assignUmpToGame(umpireId, gameId, plate, updatedGame));
    },
    getUmpireStats: (seasonId, memberId) => {
      dispatch(getUmpireStats(seasonId, memberId));
    },
    getTeamsVolunteering: (memberId, seasonId) => {
      dispatch(getTeamsVolunteering(memberId, seasonId));
    },
  };
};

const mapStateToProps = state => ({
  games: state.games.games,
  myGamesList: state.games.myGamesList,
  fetchingMyGamesStatus: state.games.fetchingMyGamesStatus,
  seasonUmpires: state.reports.seasonUmpires,
  seasonUmpiresList: state.reports.seasonUmpiresList,
  fetchingSeasonUmpireDataStatus: state.reports.fetchingSeasonUmpireDataStatus,
  seasonDivisions: state.divisions.seasonDivisions,
  seasonDivisionsList: state.divisions.seasonDivisionsList,
  fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus,
  memberId: state.user.memberId,
  userType: state.user.userType,
  umpireLevel: state.user.umpireLevel,
  userSeason: state.user.userSeason,
  umpireStats: state.reports.umpireStats,
  fetchingUmpireStatsStatus: state.reports.fetchingUmpireStatsStatus,
  teamsVolunteering: state.user.teamsVolunteering,
  teamsVolunteeringStatus: state.user.teamsVolunteeringStatus,
});

const UmpireCompletedGamesContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(UmpireCompletedGamesTable));
export default UmpireCompletedGamesContainer;



// WEBPACK FOOTER //
// ./src/containers/UmpireCompletedGamesPageContainer.js